import React, { FC } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { getInputIcon, TInputIcon } from './utils'

interface IIconForTextField {
  iconName: TInputIcon | undefined
}

const ICON_HEIGHT_PX = 20
const ICON_WIDTH_PX = 20

const useIconForTextFieldStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: ICON_HEIGHT_PX,
    width: ICON_WIDTH_PX,
    position: 'relative',
    color: brandColors.skyBlue6,
    top: -0.5,

    '& svg': {
      position: 'absolute',
      left: 0,
      width: '100%',
      top: 0,
      height: '100%',
    },
  },
})

const IconForTextField: FC<IIconForTextField> = ({ iconName }) => {
  const Icon = getInputIcon(iconName)
  const classes = useIconForTextFieldStyles()

  if (!Icon) {
    return <span />
  }

  return <Icon className={classes.root} />
}

export default IconForTextField
